import { createSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'
import { convertToGroup } from 'utils/activities'
import mapActivity from 'utils/mapActivity'

export const getIsLoaded = (state, props) => {
  return state.kanbo.bookmarks.isLoaded
}

export const getIsLoading = (state, props) => {
  return state.kanbo.bookmarks.isLoading
}

export const getLastLoadedTimestamp = (state, props) => {
  return state.kanbo.bookmarks.lastLoadedTimestamp
}

export const getBookmarkIds = (state, props) => {
  return state.kanbo.bookmarks.ids
}

export const getBookmarksById = (state, props) => {
  return state.kanbo.bookmarks.byId
}

export const bookmarksSelector = createSelector(
  [getBookmarkIds, getBookmarksById, currentUserSelector],
  (bookmarkIds, bookmarksById, currentUser) =>
    bookmarkIds
      .map(id =>
        ({
          ...bookmarksById[id],
          activityGroup: convertToGroup(mapActivity(bookmarksById[id].activity, currentUser))
        })
      )
      .sort((a, b) => b.timestamp - a.timestamp)
)

export default createSelector(
  [
    getIsLoaded,
    getIsLoading,
    getLastLoadedTimestamp,
    currentUserSelector,
    bookmarksSelector
  ],
  (
    isLoaded,
    isLoading,
    lastLoadedTimestamp,
    currentUser,
    bookmarks
  ) => ({
    isLoaded,
    isLoading,
    lastLoadedTimestamp,
    currentUser,
    bookmarks
  })
)
